import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import Button from './Button';
import Loading from './Loading';

const SUBMISSION_URL = 'https://serv-a.tntcle.com/api/breakaway/submit-designs';

function DesignSubmissionForm({ resetHasDesigns }) {
    const [files, setFiles] = useState([]);
    const [fileLocations, setFileLocations] = useState({});
    const [contactName, setContactName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);

    const onDrop = useCallback(acceptedFiles => {
        setFiles(currentFiles => [
            ...currentFiles,
            ...acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            }))
        ]);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple: true, accept: 'image/*' });

    const handleLocationChange = (file, location) => {
        setFileLocations({
            ...fileLocations,
            [file.path]: location,
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSubmitting(true);
        //scroll to the top
        window.scrollTo(0, 0);
        const formData = new FormData();
        files.forEach(file => {
            formData.append('files', file);
            formData.append('locations', fileLocations[file.path] || 'not specified'); // Include location in formData
        });
        formData.append('contactName', contactName);
        formData.append('email', email);
        formData.append('message', message);
        formData.append('phone', phone);

        try {
            const response = await axios.post(SUBMISSION_URL, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'x-api-key': "7sw73HvQdz8Eo8WrbAc14TQG9fCzuXzw",
                    'client-id': 'xo3cAksgpeqDkwaQ4'

                }
            });
            console.log('Form submitted successfully', response.data);
            // Reset form and files after successful submission
            setFiles([]);
            setContactName('');
            setEmail('');
            setMessage('');
            setPhone('');
            setSubmitting(false);
            setSubmitted(true);
        } catch (error) {
            console.error('Error submitting form', error);
            setError(error);
            setSubmitting(false);
        }
    };

    return (
        <div className={`step`} id={'designSubmissionForm'}>
            <div className="step-header d-flex w-100 align-items-center m-auto flex-column">
                <h1 className={`Heading text-center m-auto`}>Design Submission Form</h1>
            </div>
            {
                error && < div className="Error">
                    {error && <p>{error.message}</p>}
                </div>
            }
            {
                submitted ?
                    <div className="step-info text-center d-flex flex-column align-items-center">
                        <h2 className="Heading">Thank you for submitting your designs!</h2>
                        <p>Someone from out team will get back to you shortly when your designs are ready to be ordered or if they have any questions</p>
                        <Button onClick={resetHasDesigns}>Go Back</Button>
                    </div>
                    : <div className={`step-info flex-column align-items-center text-center`}>
                        <p>
                            Before you can order your practice jersey's you must submit your graphics and location information for your design. Please fill out the form below and upload your designs.
                        </p>
                        {
                            submitting ? <Loading /> : <form onSubmit={handleSubmit}>
                                <div {...getRootProps()} className="drop-zone">
                                    <input {...getInputProps()} />
                                    {
                                        isDragActive ?
                                            <p>Drop the files here ...</p> :
                                            <p>Drag 'n' drop some files here, or click to select files</p>
                                    }
                                </div>
                                <aside style={{ marginTop: '20px' }}>
                                    <h4>Files</h4>
                                    <ul>
                                        {files.map(file => (
                                            <li key={file.path}>
                                                <div>
                                                    {file.name}
                                                </div>
                                                <select value={fileLocations[file.path] || ''} onChange={(e) => handleLocationChange(file, e.target.value)}>
                                                    <option value="">Select location</option>
                                                    <option value="Back">Back</option>
                                                    <option value="Front">Front</option>
                                                    <option value="left sleeve">Left Sleeve</option>
                                                    <option value="right sleeve">Right Sleeve</option>
                                                </select>
                                            </li>
                                        ))}
                                    </ul>
                                </aside>
                                <div className="form-group">
                                    <label>
                                        Contact Name:
                                    </label>

                                    <input type="text" value={contactName} onChange={e => setContactName(e.target.value)} required />
                                </div>
                                <div className="form-group">
                                    <label>
                                        Email:
                                    </label>
                                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
                                </div>
                                <div className="form-group">
                                    <label>
                                        Phone Number:
                                    </label>
                                    <input type="phone" value={phone} onChange={e => setPhone(e.target.value)} required />
                                </div>
                                <div className="form-group">
                                    <label>
                                        Message:</label>
                                    <textarea value={message} onChange={e => setMessage(e.target.value)} required></textarea>
                                </div>
                                <div className="d-flex">
                                    <Button className="ml-2" type="button" onClick={resetHasDesigns}>Cancel </Button>

                                    <Button className="ml-2" type="Submit">Submit Designs </Button>
                                </div>
                            </form>
                        }


                    </div>
            }
        </div >


    );
}

export default DesignSubmissionForm;
